// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"promoInput_is-mob__MK5xx","is-desk":"promoInput_is-desk__NUe7_","inputPromo__text":"promoInput_inputPromo__text__3mF4m"};